import clsx from 'clsx';
import { FunctionComponent } from 'react';

type ButtonProps = JSX.IntrinsicElements['button'];

const Button: FunctionComponent<ButtonProps> = ({
  className,
  type = 'button',
  ...props
}) => {
  // gray box
  //   className = clsx(
  //     className,
  //     'cursor-pointer rounded-md border-2 border-solid border-gray-500 bg-gray-200 px-3 py-2 font-medium text-gray-900 hover:bg-gray-300 focus:bg-gray-300',
  //   );

  // pill
  className = clsx(
    className,
    'cursor-pointer rounded-full border-0 bg-gray-700 px-4 py-2 font-sans text-xs font-medium leading-3 text-white ring-blue-400 hover:bg-blue-600 focus:bg-blue-600 focus:ring-2',
  );

  return <button className={className} type={type} {...props} />;
};

Button.displayName = 'Button';

export default Button;
